import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const DEFAULTS = {
  privacy: { es: 'Politica de Privacidad', en: 'Privacy Policy' },
  terms: { es: 'Terminos de Servicio', en: 'Terms of Service' },
  about: { es: 'Acerca de ColaboraChile', en: 'About ColaboraChile' },
  contact: { es: 'Contacto', en: 'Contact' },
};

const SitePage = () => {
  const { slug } = useParams();
  const { language } = useLanguage();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${API_URL}/settings/pages/${slug}`);
        setPage(res.data);
      } catch {
        setPage(null);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [slug]);

  const defaultTitle = DEFAULTS[slug]?.[language] || slug;
  const title = page?.title || defaultTitle;
  const hasContent = page?.content && page.content.trim() !== '';

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Link
          to="/"
          className="text-sm text-purple-600 hover:text-purple-800 flex items-center gap-1 mb-6"
        >
          <ArrowLeft className="w-4 h-4" />
          {language === 'es' ? 'Volver al inicio' : 'Back to home'}
        </Link>

        {loading ? (
          <div className="flex justify-center py-20">
            <Loader2 className="w-6 h-6 animate-spin" style={{ color: '#6949b6' }} />
          </div>
        ) : (
          <>
            <h1 className="text-3xl font-bold text-gray-900 mb-8" data-testid="site-page-title">
              {title}
            </h1>
            {hasContent ? (
              <div
                className="prose prose-gray max-w-none"
                data-testid="site-page-content"
                dangerouslySetInnerHTML={{ __html: page.content }}
              />
            ) : (
              <p className="text-gray-500 italic" data-testid="site-page-empty">
                {language === 'es'
                  ? 'Esta pagina aun no tiene contenido.'
                  : 'This page has no content yet.'}
              </p>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default SitePage;
